import { render, staticRenderFns } from "./TrendCard.vue?vue&type=template&id=5222ff3f&scoped=true"
import script from "./TrendCard.vue?vue&type=script&lang=js"
export * from "./TrendCard.vue?vue&type=script&lang=js"
import style0 from "./TrendCard.vue?vue&type=style&index=0&id=5222ff3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222ff3f",
  null
  
)

export default component.exports